import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      padding: '15px 30px',
      borderRadius: 5,
      backgroundColor: theme.mode === 'dark' ? '#4c4c4c' : '#eaeaea',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 220,
      width: '100%',
      maxWidth: 400,
      boxSizing: 'border-box',
      '&>svg': {
        color: '#fff',
        fontSize: 50
      }
    }
  }
)
const PREFIX = 'NotImageStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const NotImageStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  NotImageStyle
}
